import { EntityDescriptor, EntityEditorFormSimple } from "@crispico/foundation-react";
import { ModalExt } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import React from "react";
import { Button, MenuProps, Modal, Popup, Segment } from "semantic-ui-react";
import { Scriptable, ScriptableContainer } from "@famiprog-foundation/scriptable-ui";

export interface EntityTablePageOptions { }

type EntityTablePageOptionsButtonProps<T> = {
    entityDescriptor: EntityDescriptor,
    options: T,
    onChange?: (options: T) => void
}

export class EntityTablePageOptionsButton<T extends EntityTablePageOptions = EntityTablePageOptions> extends React.Component<EntityTablePageOptionsButtonProps<T>, { modalOpen: boolean | [number, number] }> {
    editorRef = React.createRef<EntityEditorFormSimple>();

    constructor(props: EntityTablePageOptionsButtonProps<T>) {
        super(props);

        this.state = { modalOpen: false };
        this.onApply = this.onApply.bind(this);
    }

    protected getButtonId() {
        return `optionsBtnRef-${this.props.entityDescriptor.name}`;
    }

    protected openModalEditor() {
        const rect = document.getElementById(this.getButtonId())!.getBoundingClientRect();
        this.setState({ modalOpen: [rect.left, rect.bottom] });
    }

    protected onApply() {
        this.props.onChange && this.props.onChange(this.editorRef.current?.formikContext.values as T);
        this.setState({ modalOpen: false });
    }

    render() {
        return <ScriptableContainer id={`${this.props.entityDescriptor.name}Container`}><>
        <Scriptable id="Button" onClick={() => this.openModalEditor()}>{scriptable =>
            <Button id={this.getButtonId()} color="orange" onClick={() => scriptable.proxy.onClick()} icon="settings" />}</Scriptable>
            <ModalExt size="mini" open={this.state.modalOpen} onClose={() => this.setState({ modalOpen: false })}>
                <Modal.Header>{_msg("EntityTablePageOptionsButton.label")}</Modal.Header>
                <Modal.Content>
                    <EntityEditorFormSimple ref={this.editorRef}
                        entity={this.props.options}
                        entityDescriptor={this.props.entityDescriptor}
                        hideButtonBar
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Scriptable id="Apply" onClick={this.onApply}>{scriptable => <Button positive onClick={() => scriptable.proxy.onClick()}>{_msg("general.apply")}</Button>}</Scriptable>
                    <Button onClick={() => this.setState({ modalOpen: false })}>{_msg("general.cancel")}</Button>
                </Modal.Actions>
            </ModalExt>
        </></ScriptableContainer>;
    }

}

